import { useEffect, useState } from 'react';

export const useProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (progress < 100) {
      const timer = setInterval(() => {
        setProgress((prev) => prev + 1);
      }, 10);
  
      return () => {
        clearInterval(timer);
      };
    }
  
    return undefined;
  }, [progress]);

  return progress;
};